import { useRef, useState } from "react";
import {
  Box,
  TextField,
  InputAdornment
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AppButton from "../common/AppButton";
import AppSnackbar from "../common/AppSnackbar";
import AddNewShelfModal from "./addNewShelfModal";

interface Iprops {
  setReloadShelf?: any;
  search?: string;
  setSearch: (val: string) => void;
}

const ShelfToolBar = ({ setReloadShelf, setSearch }: Iprops) => {
  const [openAddSnackbar, setOpenAddSnackbar] = useState(false);
  const [addSnackbarMessage, setAddSnackbarMessage] = useState("Shelf Added Successfully!");
  const [isAddError, setIsAddError] = useState(false);
  const [isAddSuccess, setIsAddSuccess] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setSearch(val);
    }, 200);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseAddModal = () => setOpenModal(false);

  const handleAddSuccess = () => {
    setAddSnackbarMessage("Added Successfully!");
    setIsAddError(false);
    setOpenAddSnackbar(true);
    setIsAddSuccess(true);
  };

  const handleAddError = (message: string) => {
    setAddSnackbarMessage(message || "This Shelf Name already exists.");
    setIsAddError(true);
    setOpenAddSnackbar(true);
    setIsAddSuccess(false);
  };


  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          mt: 2,
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search Medicine"
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: "350px" }}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <AppButton
            title="Add New Shelf"
            onClick={handleOpenModal}
            padding="5px 10px"
            type="button"
          />
        </Box>

        {openModal && (
          <AddNewShelfModal
            handleClose={handleCloseAddModal}
            isEdit={false}
            setReloadShelf={setReloadShelf}
            onAddSuccess={handleAddSuccess}
            
            onAddError={handleAddError}
          />
        )}
      </Box>

      <AppSnackbar
        message={addSnackbarMessage}
        open={openAddSnackbar}
        handleClose={() => setOpenAddSnackbar(false)}
        severity={isAddSuccess? "success" : isAddError ? "error" : "success" }
      />
    </Box>
  );
};

export default ShelfToolBar;

